export class WriteUsDto {
    subject: string;
    remarks: string;
}